import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { validationRules } from '@/support/ValidationRules';
import { Color } from '@/models/Color';
import { SubColor } from '@/models/SubColor';

@Component<CreateSubColorDialog>({})
export default class CreateSubColorDialog extends Vue {
  @Prop({default: null})
  protected color!: Color;

  protected newSubColor: SubColor = new SubColor();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: object = validationRules(this.getTranslation);
  protected subcolorName: string  = '';

  mounted() {
    if(this.color) {
      this.newSubColor.color = this.color.id;
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected create() {
    this.isLoading = true;
    this.newSubColor
    .create()
    .then((subColor: SubColor) => {
      this.isLoading = false;
      this.$emit('subColorCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveColor() {
    if(this.newSubColor.name && this.newSubColor.color && this.newSubColor.short_name) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    return this.$tc('actions.add').toString();
  }

  protected clear() {
    this.newSubColor = new SubColor();
  }
}
